import { graphql } from '@/generated/gql';

export const CONTRACT_DEMAND_DETAIL_QUERY = graphql(/* GraphQL */ `
  query ContractDemandDetail($id: UUID!) {
    tesseract {
      contractDemand(id: $id) {
        id
        status
        priority
        sequenceNumber
        competitiveBiddingRule {
          id
          variant
          biddingPeriodDays
          deadline
          deadlineExceeded
        }
        createdAt
        updatedAt
        responsibleUserId
        tagIds
        demandRequest {
          id
          commodityGroupId
          createdAt
          currency
          incoTermsId
          paymentTermsId
          summary
          requestedAt
          totalValue
          validityPeriod {
            from
            to
          }
          lineItems {
            id
            baselinePricePerUnit
            commodityGroupId
            commodityId
            createdAt
            deliveryLocationId
            description
            minimumOrderQuantity
            quantity
            title
            unitId
          }
        }
      }
    }
  }
`);
